// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CompanyCard_wrapper__1Dy9t","invisible":"CompanyCard_invisible__88eER"};